export const removeEl = (id) => {
    const el = document.getElementById(id);

    if (el) {
        el.remove();
    }
};
